var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveIco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.846,
    height: 20.846,
    viewBox: "0 0 20.846 20.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50046",
    "data-name": "Group 50046",
    transform: "translate(-13428.912 -14118.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50046-2",
    "data-name": "Group 50046",
    transform: "translate(13429.662 14119.133)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138376",
    "data-name": "Rectangle 138376",
    width: 19.346,
    height: 19.346,
    rx: 4,
    fill: "none",
    stroke: "#000c1f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93911",
    "data-name": "Path 93911",
    d: "M1.167,12.492H4.884a2.751,2.751,0,0,1,1.2.273,2.46,2.46,0,0,1,.913.753l.185.252a2.471,2.471,0,0,0,.914.753,2.743,2.743,0,0,0,1.2.273h2.364a2.743,2.743,0,0,0,1.2-.273,2.471,2.471,0,0,0,.914-.753l.185-.252a2.46,2.46,0,0,1,.913-.753,2.751,2.751,0,0,1,1.2-.273h3.717",
    transform: "translate(-0.8 -0.985)",
    fill: "none",
    stroke: "#000c1f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_622",
    "data-name": "Line 622",
    x2: 3.529,
    transform: "translate(7.908 3.528)",
    fill: "none",
    stroke: "#000c1f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_623",
    "data-name": "Line 623",
    x2: 3.529,
    transform: "translate(7.908 7.738)",
    fill: "none",
    stroke: "#000c1f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIco);
export default __webpack_public_path__ + "static/media/archive_ico.c5491269fafdadd4929d9debac7720c3.svg";
export { ForwardRef as ReactComponent };